// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GroupStatus__container-a09a69 {
  text-align: left;
  font: var(--font-body-4);
  letter-spacing: var(--font-spacing-body-4);
  color: var(--base-80);
  display: flex;
  align-items: center;
}

.GroupStatus__loader-aa2063 {
  margin-inline-end: 6px;
}

.GroupStatus__status-da7a58 {
  text-align: left;
  color: var(--base-80);
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  min-width: 0;
}`, "",{"version":3,"sources":["webpack://./src/main/components/GroupStatus/GroupStatus.styles.m.css"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,wBAAA;EACA,0CAAA;EACA,qBAAA;EAEA,aAAA;EACA,mBAAA;AAAF;;AAGA;EACE,sBAAA;AAAF;;AAGA;EACE,gBAAA;EACA,qBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;AAAF","sourcesContent":[".container {\n  text-align: left;\n  font: var(--font-body-4);\n  letter-spacing: var(--font-spacing-body-4);\n  color: var(--base-80);\n\n  display: flex;\n  align-items: center;\n}\n\n.loader {\n  margin-inline-end: 6px;\n}\n\n.status {\n  text-align: left;\n  color: var(--base-80);\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n  min-width: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `GroupStatus__container-a09a69`,
	"loader": `GroupStatus__loader-aa2063`,
	"status": `GroupStatus__status-da7a58`
};
module.exports = ___CSS_LOADER_EXPORT___;
